import jssVariables from "../../jss_setup";

export const searchStripFlights = {
  searchStrip: {
    background: "#e8eff2",
    smallscreen: {
      background: "#b9ced8",
    },
  },
  text: {
    borderRadius: 0,
  },
  content: {
    borderRadius: 0,
  },
};

export const filtersBarFlights = {
  filtersBar: {
    background: "#e8eff2",
    smallscreen: {
      gridTemplateColumns: "1fr",
      justifyItems: "center",
      gridGap: 0,
      paddingTop: 0,
    },
  },
  btns: {
    smallscreen: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
  btnStyles: {
    ButtonDefault: {
      background: jssVariables.colors.base_color,
      borderColor: jssVariables.colors.base_color,
      "&:hover": {
        color: jssVariables.colors.base_color,
        background: "white",
      },
    },
  },
};

export const flightStyles = {
  price: {
    color: jssVariables.colors.base_color,
    fontWeight: 800,
  },
  btnStyles: {
    ButtonDefault: {
      background: "black",
      borderColor: "black",
      "&:hover": {
        color: "black",
        background: "white",
      },
    },
  },
};

export const FlightInfoPanel = {
  info: {
    fontWeight: "bold",

    smallscreen: {
      fontWeight: "normal",
    },
  },
};

export const flightFilters = {
  filtersHeader: {
    padding: `calc(${jssVariables.normal_gap} * 3)`,
    paddingBottom: `calc(${jssVariables.normal_gap} * 2)`,
  },
  form: {
    padding: `0 calc(${jssVariables.normal_gap} * 3)`,
  },
  actions: {
    padding: `calc(${jssVariables.normal_gap} * 3)`,
  },
};

export const FlsModalViewSelection = {
  price: {
    color: jssVariables.colors.base_color,
    fontWeight: 800,
    fontSize: "large",
  },
  closeIconX: {
    color: "#165C7D",
  },
  planeIcon: {
    color: jssVariables.colors.base_color,
  },
  flightInfoHeader: {
    fontWeight: "bold",
  },
};
